import qs from "qs";
import authAxios, { authHeader } from "./data";

const fetchProviders = async () => {
  const response = await authAxios.get(`/api/payment-providers/methods`, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchProvider = async (id: string) => {
  const response = await authAxios.get(`/api/payment-providers/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchSaved = async (request: any) => {
  const response = await authAxios.get("/api/payment-providers/vault/methods", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const remove = async (req: any) => {
  const response = await authAxios.delete(
    `/api/payment-providers/vault/methods/${req.id}`,
    {
      params: req,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
    },
  );

  return response.data;
};

const providerPayment = async (request: any) => {
  const result = await authAxios.post(
    "/api/payment-providers/payments",
    request,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

const initialize = async (contractNumber: string) => {
  const response = await authAxios.get(
    `/api/payment-providers/payments/${contractNumber}/initialize`,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const PortalPaymentsService = {
  fetchProviders,
  fetchProvider,
  fetchSaved,
  remove,
  providerPayment,
  initialize,
};

export default PortalPaymentsService;
